$(document).ready(function(){

  // adjusting values from - and + icons of cart
  
  // inititate main quantity changer
  attachCartEvents();

  // attach event listner for the cart change
  document.addEventListener("cart:change", function(){
     
      //console.log('kevin');
      
      setTimeout(function(){
          attachCartEvents();
      }, 2000);
  }); 

  // update cart items
  function updateCartItem( variant_id, quantity, operation){
      
      //co
      var data = { updates: {} };
      var item_count;
      //var data = [{ quantity: quantity, id: variant_id }];
      data.updates[variant_id] = quantity;
      
      $(".loading_wait").show();
      $(".loading_overlay").show();

      jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: data,
          dataType: 'json',
          success: function(result) { 
             
              $.when( 
                  jQuery.getJSON('/cart.js', function(cart) {
                      
                      item_count = cart.item_count;
                      let cartData = cart.items;
                      document.dispatchEvent(new CustomEvent('cart:build' ,{
                              bubbles: true
                          }
                      )); 
                      document.dispatchEvent(new CustomEvent('cart:refresh', {
                          bubbles: true,
                          detail: cartData
                      })); 
                  })
              ).then(function(){
                  
                  setTimeout(function(){
                      
                      // don't re-attach
                      if( window.location.pathname.indexOf('/cart/') == -1)
                          attachCartEvents();

                      $(".header__cart-count").find(".count-bubble").html(item_count);
                      $(".loading_wait").hide();
                      $(".loading_overlay").hide();
                      
                      // console.log('re-attached');
                  }, 2000);

              });
          }
      });
  }



  function justRefresh(){
      
    var data = { updates: {} };
    var item_count;
    
    $(".loading_wait").show();
    $(".loading_overlay").show();
  
    jQuery.ajax({
        type: 'GET',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(result) { 
           
            $.when( 
                jQuery.getJSON('/cart.js', function(cart) {
                    
                    item_count = cart.item_count;
                    let cartData = cart.items;
                    document.dispatchEvent(new CustomEvent('cart:build' ,{
                            bubbles: true
                        }
                    )); 
                    document.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true,
                        detail: cartData
                    })); 
                })
            ).then(function(){
                
                setTimeout(function(){
                    
                    // don't re-attach
                    if( window.location.pathname.indexOf('/cart/') == -1)
                        attachCartEvents();
  
                    $(".loading_wait").hide();
                    $(".loading_overlay").hide();
                    
                    // console.log('re-attached');
                }, 2000);
  
            });
  
            // console.log(result);
        }
    });
  }

  // main function for event attaching event listners
  function attachCartEvents(){
      $('.remove_item').click(function(){
        var variant_id = $(this).parents('.line_changer').attr("line_var_id");
        
        updateCartItem(variant_id, 0, 'remove'); 
      });

      $(".i_minus_cart").click(function(){
          //console.log("MINUS");
          
          var minus;
          
          let $inputBox = $(this).parents('.line_changer').find('input.quantity-input');

          minus = parseInt( $inputBox.attr('value') ) - 1;
          
          $inputBox.attr('value', minus);
          
          //console.log($inputBox.attr('value'));
          //console.log(minus);
          //$(this).parents('.line-item').find('.line_item_hdn').find('input.quantity-input').attr('value', minus);
  
          var variant_id = $(this).parents('.line_changer').attr("line_var_id");
        
          updateCartItem(variant_id, minus, 'minus'); 
  
      });
      
      $(".i_plus_cart").click(function(){
          //console.log('PLUS')
          
          var plus, max, currrent_qty;
          let $inputBox = $(this).parents('.line_changer').find('input.quantity-input');
          
          currrent_qty = parseInt( $inputBox.attr('value') );
          plus = currrent_qty + 1;
              
          $inputBox.attr('value', plus);

          //console.log(currrent_qty);
          //console.log(plus);
          //$(this).parents('.line-item').find('.line_item_hdn').find('input.quantity-input').attr('value', plus);

          var variant_id = $(this).parents('.line_changer').attr("line_var_id");
          updateCartItem(variant_id, plus, 'plus'); 
  
      });
    
      $("#nector-useyourcoins-container").click(function(){
          // justRefresh(); 
      });
    
  }
  
});

$(document).ready(function(){
  $("li.main_menu_cu").on("click", function(){
    $("li.main_menu_cu a.h5 span").css('color', '#ADAEB3');
    $(this).children("a").children("span").css('color', '#2B514D');

    // Always hide all submenus first
    $("ul.sub_menu_cu").hide();

    let $child_mm = $(this).find("ul.sub_menu_cu");

    // Only show submenu if it exists
    if($child_mm.length > 0){
      $child_mm.css('display', 'flex');
    }
  });
});

(function () { // close accordion when current one is opened
  const SEL = 'details[is="accordion-disclosure"], accordion-disclosure';

  function isAccordion(el) {
    return !!el && (el.matches?.(SEL));
  }

  // Find the group container so we only close siblings in the same block/section.
  function getGroupRoot(acc) {
    // Prefer a nearby ancestor that actually contains multiple accordions.
    let node = acc.parentElement;
    for (let i = 0; i < 6 && node; i++) {
      const count = node.querySelectorAll(SEL).length;
      if (count > 1) return node;
      node = node.parentElement;
    }
    return acc.parentElement || document; // safe fallback
  }

  function closeSiblingsOf(acc) {
    const root = getGroupRoot(acc);
    const list = root.querySelectorAll(SEL);
    list.forEach((other) => {
      if (other !== acc && other.open) {
        // Use the component's own API so Impact's animation runs
        other.open = false;
      }
    });
  }

  // 1) Capture click on <summary> before Impact toggles 'open'
  document.addEventListener('click', function (e) {
    const summary = e.target.closest('summary');
    if (!summary) return;

    const acc = summary.closest(SEL);
    if (!isAccordion(acc)) return;

    // If it's currently closed, it's about to open -> close others first
    // (We are in capture phase, before the theme flips open state)
    if (!acc.open) {
      closeSiblingsOf(acc);
    }
  }, true); // <- capture

  // 2) Also watch for programmatic opens (Theme Editor, JS) and enforce one-open rule
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'open') {
        const acc = m.target;
        if (isAccordion(acc) && acc.open) {
          closeSiblingsOf(acc);
        }
      }
    }
  });

  mo.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });

  // Optional: re-enforce after Shopify section loads in editor/live
  document.addEventListener('shopify:section:load', (evt) => {
    const root = evt.target || document;
    root.querySelectorAll(SEL).forEach((acc) => {
      if (acc.open) closeSiblingsOf(acc);
    });
  });
})();